import React, { useState } from "react";
import { Download, Package, Info, Link, Copy, RefreshCw } from "lucide-react";
import toast from "react-hot-toast";

const API = process.env.REACT_APP_API_URL || "http://185.143.228.169:6938";

const SOFTWARE_INFO = {
  name: "PipoClient",
  version: "1.0.0",
  size: "~59 MB",
};

export default function DownloadPage() {
  const [generating, setGenerating] = useState(false);
  const [generatedLink, setGeneratedLink] = useState("");
  const [hwid, setHwid] = useState("");
  const adminKey = localStorage.getItem("adminKey") || "";

  const handleGenerate = async () => {
    setGenerating(true);
    setGeneratedLink("");
    try {
      const params = new URLSearchParams();
      if (hwid.trim()) params.append("hwid", hwid.trim());
      const r = await fetch(
        `${API}/admin/generate_download?${params.toString()}`,
        { method: "POST", headers: { "x-admin-key": adminKey } }
      );
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      const d = await r.json();
      setGeneratedLink(d.url);
      toast.success("Link berhasil dibuat â€” berlaku 1x, 5 menit");
    } catch (e) {
      toast.error("Gagal generate link: " + e.message);
    } finally {
      setGenerating(false);
    }
  };

  const handleCopy = () => {
    if (!generatedLink) return;
    navigator.clipboard.writeText(generatedLink);
    toast.success("Link disalin!");
  };

  return (
    <div style={s.page}>
      <div style={s.header}>
        <h1 style={s.title}>Download Software</h1>
        <p style={s.sub}>Generate one-time link untuk customer â€” berlaku 1x klik, 5 menit</p>
      </div>

      <div style={s.grid}>
        {/* Card kiri â€” generate link */}
        <div style={s.card}>
          <div style={s.cardIcon}><Package size={40} color="#6366f1" /></div>
          <h2 style={s.cardTitle}>{SOFTWARE_INFO.name}</h2>
          <p style={s.cardVersion}>v{SOFTWARE_INFO.version} Â· {SOFTWARE_INFO.size}</p>

          {/* HWID optional */}
          <div style={s.inputGroup}>
            <label style={s.label}>HWID Customer (opsional)</label>
            <input
              style={s.input}
              placeholder="Kosongkan jika tidak perlu"
              value={hwid}
              onChange={e => setHwid(e.target.value)}
            />
          </div>

          <button onClick={handleGenerate} disabled={generating} style={s.genBtn}>
            {generating
              ? <><RefreshCw size={16} style={{animation:"spin 1s linear infinite"}} /> Generating...</>
              : <><Link size={16} /> Generate Download Link</>
            }
          </button>

          {/* Hasil link */}
          {generatedLink && (
            <div style={s.linkBox}>
              <div style={s.linkLabel}>
                <span style={{color:"#4ade80", fontWeight:600}}>âœ“ Link siap</span>
                <span style={{color:"#64748b", fontSize:11}}>1x pakai Â· expired 5 menit</span>
              </div>
              <div style={s.linkRow}>
                <span style={s.linkText}>{generatedLink}</span>
                <button onClick={handleCopy} style={s.copyBtn}>
                  <Copy size={14} />
                </button>
              </div>
              <p style={s.linkHint}>
                Kirim link ini ke customer. Setelah diklik sekali, link <b style={{color:"#f87171"}}>tidak bisa dipakai lagi</b>.
              </p>
            </div>
          )}

          {/* Info isi ZIP */}
          <div style={s.zipBox}>
            <div style={s.zipTitle}>ðŸ“¦ Isi ZIP:</div>
            {[
              ["PipoClient.exe", "Program utama"],
              ["akun.txt",       "Daftar akun (email|password|link)"],
              ["data.txt",       "DANA (nomor|pin)"],
              ["proxy.txt",      "Proxy (opsional)"],
            ].map(([f, d]) => (
              <div key={f} style={s.zipRow}>
                <span style={s.zipFile}>{f}</span>
                <span style={s.zipDesc}>{d}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Card kanan â€” instruksi */}
        <div style={s.infoCard}>
          <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:16 }}>
            <Info size={18} color="#6366f1" />
            <h3 style={{ color:"#fff", margin:0, fontSize:15, fontWeight:600 }}>Cara Penggunaan</h3>
          </div>
          <ol style={s.steps}>
            {[
              <>Generate link di halaman ini</>,
              <>Kirim link ke customer via Telegram/WA</>,
              <>Customer klik link â†’ download otomatis</>,
              <>Link <b style={{color:"#f87171"}}>langsung expired</b> setelah diklik</>,
              <>Extract ZIP â†’ jalankan <b>PipoClient.exe</b></>,
              <>Program tampilkan <b>HWID</b> â†’ kirim ke admin</>,
              <>Admin daftarkan HWID â†’ customer langsung bisa pakai</>,
            ].map((step, i) => (
              <li key={i} style={s.step}>
                <span style={s.stepNum}>{i+1}</span>
                <span>{step}</span>
              </li>
            ))}
          </ol>

          <div style={s.noteYellow}>
            <span style={{ color:"#f59e0b", fontWeight:600 }}>ðŸ”’ Keamanan: </span>
            <span style={{ color:"#94a3b8", fontSize:12 }}>
              Setiap customer dapat link unik berbeda. Tidak ada URL statis yang bisa disebarkan.
              Link expired otomatis setelah 5 menit walau belum diklik.
            </span>
          </div>

          <div style={{ ...s.noteBlue, marginTop:10 }}>
            <div style={{ color:"#a5b4fc", fontWeight:600, marginBottom:6 }}>ðŸ“„ Format akun.txt:</div>
            <pre style={s.pre}>{`email|password|link\nuser@gmail.com|pass123|https://cashier-...`}</pre>
          </div>
          <div style={{ ...s.noteBlue, marginTop:10 }}>
            <div style={{ color:"#a5b4fc", fontWeight:600, marginBottom:6 }}>ðŸ“± Format data.txt (DANA):</div>
            <pre style={s.pre}>{`nomor|pin\n085612345678|123456`}</pre>
          </div>
        </div>
      </div>
    </div>
  );
}

const s = {
  page:      { padding:"32px 32px 32px 252px", minHeight:"100vh", fontFamily:"'Segoe UI',sans-serif" },
  header:    { marginBottom:28 },
  title:     { color:"#fff", fontSize:24, fontWeight:700, margin:0 },
  sub:       { color:"#64748b", fontSize:13, marginTop:4 },
  grid:      { display:"grid", gridTemplateColumns:"400px 1fr", gap:20, alignItems:"start" },
  card:      { background:"rgba(255,255,255,0.04)", border:"1px solid rgba(255,255,255,0.1)", borderRadius:16, padding:28, textAlign:"center" },
  cardIcon:  { background:"rgba(99,102,241,0.12)", borderRadius:"50%", width:72, height:72, display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 14px", border:"1px solid rgba(99,102,241,0.3)" },
  cardTitle: { color:"#fff", fontSize:20, fontWeight:700, margin:"0 0 4px" },
  cardVersion:{ color:"#6366f1", fontSize:13, margin:"0 0 20px", fontWeight:600 },
  inputGroup:{ textAlign:"left", marginBottom:12 },
  label:     { display:"block", color:"#94a3b8", fontSize:12, marginBottom:6 },
  input:     { width:"100%", padding:"9px 12px", background:"rgba(255,255,255,0.06)", border:"1px solid rgba(255,255,255,0.12)", borderRadius:8, color:"#e2e8f0", fontSize:13, boxSizing:"border-box", outline:"none" },
  genBtn:    { width:"100%", padding:"13px 0", background:"linear-gradient(135deg,#6366f1,#8b5cf6)", border:"none", borderRadius:10, color:"#fff", fontSize:14, fontWeight:700, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", gap:8, marginBottom:16 },
  linkBox:   { background:"rgba(74,222,128,0.06)", border:"1px solid rgba(74,222,128,0.25)", borderRadius:10, padding:14, marginBottom:16, textAlign:"left" },
  linkLabel: { display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:8 },
  linkRow:   { display:"flex", alignItems:"center", gap:8, background:"rgba(0,0,0,0.3)", borderRadius:6, padding:"8px 10px", marginBottom:8 },
  linkText:  { flex:1, fontFamily:"monospace", fontSize:11, color:"#a5b4fc", wordBreak:"break-all" },
  copyBtn:   { background:"rgba(99,102,241,0.3)", border:"1px solid rgba(99,102,241,0.5)", borderRadius:6, padding:"5px 8px", color:"#a5b4fc", cursor:"pointer" },
  linkHint:  { color:"#64748b", fontSize:11, margin:0 },
  zipBox:    { background:"rgba(99,102,241,0.08)", border:"1px solid rgba(99,102,241,0.2)", borderRadius:8, padding:12, textAlign:"left" },
  zipTitle:  { color:"#a5b4fc", fontSize:12, fontWeight:600, marginBottom:8 },
  zipRow:    { display:"flex", justifyContent:"space-between", padding:"3px 0" },
  zipFile:   { fontFamily:"monospace", fontSize:12, color:"#e2e8f0" },
  zipDesc:   { color:"#64748b", fontSize:11 },
  infoCard:  { background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.08)", borderRadius:16, padding:24 },
  steps:     { listStyle:"none", padding:0, margin:"0 0 16px", display:"flex", flexDirection:"column", gap:8 },
  step:      { display:"flex", alignItems:"center", gap:10, color:"#cbd5e1", fontSize:13 },
  stepNum:   { minWidth:24, height:24, borderRadius:"50%", background:"rgba(99,102,241,0.2)", border:"1px solid rgba(99,102,241,0.4)", color:"#a5b4fc", fontSize:11, fontWeight:700, display:"flex", alignItems:"center", justifyContent:"center" },
  noteBlue:  { background:"rgba(99,102,241,0.08)", border:"1px solid rgba(99,102,241,0.2)", borderRadius:8, padding:"10px 14px" },
  noteYellow:{ background:"rgba(245,158,11,0.08)", border:"1px solid rgba(245,158,11,0.2)", borderRadius:8, padding:"10px 14px", fontSize:12 },
  pre:       { fontFamily:"monospace", fontSize:11, color:"#94a3b8", lineHeight:1.7, margin:0, whiteSpace:"pre-wrap" },
};

